import { Injectable } from "@angular/core";
import { Actions, Effect } from "@ngrx/effects";
import { Role } from "@models/role";
import { Action } from "@ngrx/store";
import {
  FETCH_ROLES,
  FETCH_ROLES_FAILURE,
  POPULATE_ROLES,
  FETCH_ROLE_USERS,
  POPULATE_ROLE_USERS,
  FETCH_ROLE_USERS_FAILURE
} from "../roles";
import { RoleService } from "@services/role";
import { Observable } from "rxjs/Observable";
import { User } from "@models/user";

@Injectable()
export class RoleEffects {

  constructor(
    private actions: Actions,
    private roleService: RoleService,
  ) {}

  @Effect() index = this.actions
    .ofType(FETCH_ROLES)
    .map((action: Action) => action.payload)
    .switchMap((params: any) => this.roleService.index(params)
      .map((roles: Role[]) => ({ type: POPULATE_ROLES, payload: roles }))
      .catch((response: any) => Observable.of({ type: FETCH_ROLES_FAILURE, payload: response }))
    )
    .share()

  @Effect() roleUsers = this.actions
    .ofType(FETCH_ROLE_USERS)
    .map((a: Action) => a.payload)
    .switchMap((roleId: number) => this.roleService.roleUsers(roleId)
      .map((users: User[]) => ({ type: POPULATE_ROLE_USERS, payload: users }))
      .catch((response: any) => Observable.of({ type: FETCH_ROLE_USERS_FAILURE, payload: response }))
    )
    .share()
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/effects/role.ts